// src/hooks/use-native-credential-sync.ts
import { useEffect } from 'react';
import { isNative } from '../platform';
import { storeNativeCredentials } from '../helpers/native-biometric';
import { BiometricsStorage } from '../helpers/biometrics-storage';

/**
 * Keeps the native Keystore/Keychain credentials in sync with the
 * current session. Call this in the auth context or main app shell.
 */
export function useNativeCredentialSync(userId: string | null, refreshToken: string | null) {
  useEffect(() => {
    if (!isNative()) return;
    if (!userId || !refreshToken) return;
    if (!BiometricsStorage.isBiometricsEnabled()) return;

    storeNativeCredentials(userId, refreshToken).catch(() => {
      // Non-critical — next successful biometric login will re-store
    });
  }, [userId, refreshToken]);
}
